import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import BoxShadow from "../../../shared/BoxShadow/BoxShadow";
import AlumniStoriesContent from "../../../components/AdminPanel/AlumniStories/AlumniStoriesContent";

const AlumniStories = () => {
  return (
    <AdminPanelLayout>
      <BoxShadow>
        <div className="mt-7">
          <AlumniStoriesContent />
        </div>
      </BoxShadow>
    </AdminPanelLayout>
  );
};

export default AlumniStories;
